import { render, staticRenderFns } from "./ReportImagesRemark.vue?vue&type=template&id=600ce095&"
import script from "./ReportImagesRemark.vue?vue&type=script&lang=js&"
export * from "./ReportImagesRemark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QItem,QInput,QCheckbox,QTooltip} from 'quasar'
component.options.components = Object.assign({QBtn,QItem,QInput,QCheckbox,QTooltip}, component.options.components || {})
